import { ErrorType } from "src/modules/parent-station/lib/createErrorManager";

export default function getStrings(t, error) {
  switch (error) {
    case ErrorType.BABY_LOST_CONNECTION:
      return {
        heading: t("connectionLost.heading"),
        text: t("parentStation.errors.babyLostConnection.text")
      };
    case ErrorType.BABY_LOST_AUDIO:
      return {
        heading: t("parentStation.errors.babyLostAudio.heading"),
        text: t("parentStation.errors.babyLostAudio.text")
      };
    case ErrorType.BABY_INTERUPTED_AUDIO:
      return {
        heading: t("parentStation.errors.babyInteruptedAudio.heading"),
        text: t("parentStation.errors.babyInteruptedAudio.text")
      };
    case ErrorType.BABY_ON_BACKGROUND:
      return {
        heading: t("parentStation.errors.babyOnBackground.heading"),
        text: t("parentStation.errors.babyOnBackground.text")
      };
    case ErrorType.CONNECTION_LOST:
    default:
      return {
        heading: t("parentStation.errors.connectionLost.heading"),
        text: t("messages.reconnecting")
      };
  }
}
